import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import { Stack } from '@famly/mf_layout_stack';
import { useBreakpoints } from '@famly/mf_util_breakpoints';
import { relations } from 'signin-app/child/selectors';
import * as CheckInSelectors from 'signin-app/child/check-in/selectors';
import { selectPickupRelation } from 'signin-app/child/check-in/actions';
import { SelectablePersonButton } from 'signin-app/components/selectable-person-button';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
const ChildRelations = (props) => {
    const { handleRelationClick, children } = props;
    const childRelations = useTypedSelector(state => relations(state, props));
    const selectedPickupRelationId = useTypedSelector(CheckInSelectors.selectedPickupRelationId);
    const { isTabletPortraitAndLarger } = useBreakpoints();
    const dispatch = useDispatch();
    const handleClick = async (relationId) => {
        await dispatch(selectPickupRelation.action(relationId));
        handleRelationClick();
    };
    return (_jsxs(Stack, { my: 2, flexWrap: "wrap", children: [childRelations.map(relation => (_jsx(SelectablePersonButton, { image: relation.image.large, initials: `${relation.name.firstName.charAt(0)}${relation.name.lastName.charAt(0)}`, name: relation.name.firstName, onClick: () => handleClick(relation.relationId), selected: selectedPickupRelationId === relation.relationId, dataE2eClass: "child-person-card-title", size: isTabletPortraitAndLarger ? 'lg' : 'md' }, relation.relationId))), children] }));
};
export default ChildRelations;
